/**
 * Get text from config enum
 *
 * @param enumList Array with enum config values
 * @param value Value to search for
 * @param prop Property to return
 * @param defaultText Returned if no result found
 * @returns {string}
 */
const configEnumProp = (enumList, value, prop, defaultText = '') => {
    const result = enumList.find(item => item.value === value);
    return result[prop] || defaultText;
};
export default configEnumProp;
